import QuizItemReorder from '../components/pages/quiz/quizItemReorder/QuizItemReorder';
import QuizItem from '../components/pages/quiz/QuizItem';
import QuizItemAnswer from '../components/pages/quiz/quizItemAnswer/QuizItemAnswer';
import QuizItemMultiple from '../components/pages/quiz/quizItemMultiple/QuizItemMultiple';
import QuizItemRebus from '../components/pages/quiz/quizItemRebus/QuizItemRebus';
import QuizItemPuzzle from '../components/pages/quiz/quizItemPuzzle/QuizItemPuzzle';
import QuizGuessForm from '../components/pages/quiz/quizGuessForm/QuizGuessForm';

export const useQuizComponents = ({ currentQuiz, activeItem, setScore, nextStep, buttonId, setButtonId, isNY }) => {
  const index = activeItem + 1;

  const props = {
    index,
    setScore: (id) => setScore(id),
    nextStep,
    buttonId,
    setButtonId,
    isNY,
    ...currentQuiz?.questions?.[activeItem],
  };

  const componentsData = {
    Order: { Component: QuizItemReorder, props },
    Simple: { Component: QuizItem, props },
    YesNo: { Component: QuizItemAnswer, props },
    Multiple: { Component: QuizItemMultiple, props },
    Rebus: { Component: QuizItemRebus, props },
    Puzzle: { Component: QuizItemPuzzle, props },
    GuessForm: { Component: QuizGuessForm, props },
  };

  return { ...componentsData, props };
};
